import { LoginResponse } from "./LoginResponse";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ResetPasswordResponse extends LoginResponse {}

export enum ResetPasswordResponseStatusCodes {
  BadRequest = 400,
  Invalid = 403,
}
